import React from "react";

/**
 * Shown when the sign-in service (Clerk) can't be loaded at all, so nothing
 * else can start. Plain inline styles, like the app's error boundary, because
 * nothing else on the page has loaded.
 */
function SignInUnavailable() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "#f8f5eb",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "460px",
          textAlign: "center",
          background: "#ffffff",
          border: "1px solid #e4dfd2",
          borderRadius: "14px",
          padding: "32px 28px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        }}
      >
        <div style={{ fontSize: "44px", marginBottom: "10px" }}>🌿</div>
        <h1
          style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            color: "#1f2a44",
            fontSize: "24px",
            margin: "0 0 10px",
          }}
        >
          We can't reach the sign-in service
        </h1>
        <p style={{ color: "#444", fontSize: "16px", lineHeight: 1.55, margin: "0 0 22px" }}>
          We can't reach the sign-in service right now — please refresh the page
          in a moment. Your information is safe.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: "#1f2a44",
            color: "#ffffff",
            border: "none",
            borderRadius: "10px",
            padding: "12px 26px",
            fontSize: "16px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Refresh the page
        </button>
      </div>
    </div>
  );
}

export default SignInUnavailable;
